import {fetchVirtualStore, storeOutlet, insertOutletAncillaryData} from '../service/Outlet';

export const getCodeByLabel = (data, labelToMatch) => {
  for (const item of data) {
    if (item.label.toLowerCase().includes(labelToMatch.toLowerCase())) {
      return item.code;
    }
  }
  return null;
};

export const getVirtualStoreDetails = async (storeCode, channelName, countryCodes) => {
  const response = await fetchVirtualStore(storeCode);
  if (response?.success === false) {
    return {error: 1, message: response.error || 'Something Went Wrong'};
  }
  const data = response.data?.data?.data;
  if (data?.status !== 200) {
    return {error: 1, message: data?.data?.message?.default || data?.data?.message || 'Something Went Wrong'};
  }
  let partnerChannelCode;
  let channelMenuData;
  for (const channelMenu of data.data?.data?.channelMenuList?.list || []) {
    if (channelMenu.channelResponse?.name.replace(/\s+/g, '').toLowerCase() === channelName.toLowerCase()) {
      partnerChannelCode = channelMenu.channelResponse.code;
      channelMenuData = channelMenu;
      break;
    }
  }
  if (!partnerChannelCode) {
    return {error: 1, message: `No record for VirtualStore with code ${storeCode} & channel ${channelName}`};
  }
  const storeData = data.data?.data;
  return {
    partnerStoreCode: storeCode,
    partnerChannelCode,
    city: storeData?.physicalStore?.city,
    countryName: storeData?.physicalStore?.country,
    partnerBrandName: storeData?.brand?.name,
    partnerBrandCode: storeData?.brand?.code,
    partnerPhyStoreName: storeData?.physicalStore?.name,
    partnerPhyStoreCode: storeData?.physicalStore?.code,
    countryCode: storeData?.virtualStoreBusiness?.cityResponse?.countryResponse?.shortCode,
    storeDetails: {
      restaurant_name: storeData?.brand?.name,
      brand_code: storeData?.brand?.code,
      brand_name: storeData?.brand?.name,
      physical_store_code: storeData?.physicalStore?.code,
      physical_store_name: storeData?.physicalStore?.name,
      restaurant_code: storeData?.code,
      min_order_value: channelMenuData?.minOrderValue?.toString() || '0',
      delivery_cost: channelMenuData?.deliveryFeeResponse?.amount?.toString() || '0',
      address: storeData?.physicalStore?.address,
      landmark: storeData?.physicalStore?.landmark,
      postal_code: storeData?.physicalStore?.postalCode,
      city: storeData?.physicalStore?.city,
      state: storeData?.physicalStore?.state,
      company_name: storeData?.virtualStoreBusiness?.legalName,
      vendor_pan_number: storeData?.virtualStoreBusiness?.tinNumber,
      gst_number: storeData?.tinNumber,
      fssai_number: storeData?.restaurantLicenseNumber,
      fssai_valid_upto: storeData?.licenseExpiryDate,
      logo: storeData?.brand?.mediaResponse?.imageUrl,
      email: storeData?.physicalStore?.emailAddress,
      phone_number: storeData?.physicalStore?.phoneNumber,
    },
  };
};

export const getChannelDetails = (channel, commonFilters) => {
  const filterData = commonFilters?.channelCode?.find((c) => channel === c.label);
  if (filterData?.code) {
    const [channelGroupCode, channelCode] = filterData?.code?.split('-') || [];
    let [channelGroupName, channelName] = channel?.split('-') || [];
    if (channelName === 'direct') {
      channelName = channelGroupName;
    }
    return {channelName, channelGroupName, channelCode, channelGroupCode};
  } else {
    return {error: 1, message: `Invalid Channel ${channel}`};
  }
};

export const createAncillary = async (fileData) => {
  const data = fileData
    .filter((row) => !row.error)
    .map((row) => {
      return {
        partnerStoreCode: row.partnerStoreCode,
        partnerCode: 'ODPT00002',
        channelCode: row.channelCode,
        stationCode: row.stationCode,
        cutOffTimeMin: Number(row.cutOffTime),
        allowedPaymentMode: row.allowedPaymentMode.split('-').join(','),
        latitude: row.latitude,
        longitude: row.longitude,
        isActive: 'active',
        createdBy: row.createdBy,
        updatedBy: row.updatedBy,
      };
    });
  if (!data?.length) {
    return {data: [], success: false, message: 'Validation Failed'};
  }
  const result = await insertOutletAncillaryData({data: {ancillary: data}});
  if (result.status !== 200) {
    return {
      data: [],
      success: false,
      message: `${result.data?.data?.error || result.data?.data?.message}`,
    };
  }
  const ancillaryResult = {};
  result.data?.data?.data?.forEach((item) => {
    ancillaryResult[item?.key] = {
      status: item.status,
      message: item?.message,
      insertId: item?.result?.insertId,
    };
  });
  return {data: ancillaryResult, success: true};
};

export const createOutlets = async (outlets) => {
  const data = outlets
    .filter((row) => !row.error)
    .map((row) => {
      return {
        partnerStoreCode: row.partnerStoreCode,
        partnerCode: row.partnerCode,
        channelCode: row.channelCode,
        channelGroupCode: row.channelGroupCode,
        channelStoreGroupCode: row.channelStoreCode,
        channelStoreCode: row.channelStoreCode,
        partnerChannelCode: row.partnerChannelCode,
        partnerPhyStoreCode: row.partnerPhyStoreCode,
        partnerPhyStoreName: row.partnerPhyStoreName,
        partnerBrandCode: row.partnerBrandCode,
        partnerBrandName: row.partnerBrandName,
        city: row.city,
        countryCode: row.countryCode,
        countryName: row.countryName,
        channelBrandAuthKey: row.channelBrandAuthKey,
        mappingStatus: row.mappingStatus,
        createdBy: row.createdBy,
        updatedBy: row.updatedBy,
      };
    });
  if (!data?.length) {
    return {data: [], success: false, message: 'Validation Failed'};
  }
  const outletInsert = await storeOutlet({data: data});
  if (outletInsert.status !== 200) {
    return {
      data: [],
      success: false,
      message: `${outletInsert.data?.data?.error || outletInsert.data?.data?.message}`,
    };
  }
  const outletResults = {};
  outletInsert.data?.data?.data?.forEach((item) => {
    outletResults[item?.key] = {
      status: item.status,
      message: item?.message,
      insertId: item?.result?.insertId,
    };
  });
  return {data: outletResults, success: true};
};

export const getFailureReason = (reason) => {
  if (reason.toLowerCase().includes('duplicate entry')) {
    return 'Duplicate Entry';
  }
  return reason?.replace(/,/g, ' ');
};
